// extracted by mini-css-extract-plugin
var _1 = "container--XaexJ3Wk";
export { _1 as "container" }
